export const MOCK_DATA_BUSINESS = {
  id: 'null',
  markaaz_verified: true,
  claimed: true,
  claimed_at: '2022-03-09T00:01:32.000Z',
  markaaz_verify_date: new Date('2022-03-09T00:05:32.000Z'),
  business_uri: 'www.markaaz.com',
  credit_score: 650,
  credit_score_max: 800,
  credit_risk_score: 'Unavailable',
  credit_risk_score_max: 660,
  credit_class: 'Unavailable',
  primary_conatct: {
    fname: 'hany',
    lname: 'fam',
    email: 'hany.fam@markaaz.com',
  },
  key_secondary_contact: [
    {
      fname: 'fabi',
      lname: 'hubschimd',
      email: 'fabi.hubschimd@markaaz.com',
    },
    {
      fname: 'jerry',
      lname: 'mccarley',
      email: 'jerry.mccarley@markaaz.com',
    },
    {
      fname: 'omar',
      lname: 'saleh',
      email: 'omar.saleh@markaaz.com',
    },
  ],
  profile_completion: 85,
}
export const MOCK_USER_COMPLETION = 85
